import './StandardButton.css';
import { Button, CircularProgress } from '@mui/material';

function StandardButton({ label, type, size, onClick, loading, disabled, variant, bg, sx }) {
    return (
        <Button disableElevation variant={variant || 'contained'} fullWidth type={type || 'button'} size={size || 'medium'}
            disabled={loading || disabled} className='standard_btn' onClick={onClick}
            sx={{ ...sx, backgroundColor: `${bg || '#006494'} !important` }}
        >

            {loading ? (
                <CircularProgress sx={{ color: '#fff', marginBottom: '2px' }} size={30} />
            ) : <>{label}</>}

        </Button>
    )
}

export default StandardButton